import ActionTypes from "./ActionTypes";
export const getPagesData = (payload) => {
  return {
    type: ActionTypes.GET_PAGES_INFORMATION,
    payload,
  };
};
